import { createSlice } from '@reduxjs/toolkit'

const authState = {
  user: JSON.parse(localStorage.getItem('user')) || null,
  token: localStorage.getItem('token') || null,
  r_token: localStorage.getItem('r_token') || null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState: authState,
  reducers: {
    login(state, action) {
      state.user = action.payload.user
      state.token = action.payload.token
      state.r_token = action.payload.refresh_token
      localStorage.setItem('user', JSON.stringify(state.user));
      localStorage.setItem('token', state.token);
      localStorage.setItem('r_token', state.r_token);
    },
    logout(state) {
      state.user = null
      state.token = null
      state.r_token = null
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      localStorage.removeItem('r_token');
    },
  },
})

export const { login, logout } = authSlice.actions

export default authSlice.reducer
